import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next'

import ContactSalesModal from '@/shared/ContactSalesModal'
import { InfoSVGIcon } from '@/components/icons'

// Which flow the visitor is in — only the subtitle changes between the two.
export type FreeTrialLinkBannerVariant = 'login' | 'create-account'

const SUBTITLE_KEYS: Record<FreeTrialLinkBannerVariant, string> = {
  login: 'free_trial_link_banner.login_subtitle',
  'create-account': 'free_trial_link_banner.create_account_subtitle',
}

type FreeTrialLinkBannerProps = {
  variant: FreeTrialLinkBannerVariant
}

export const FreeTrialLinkBanner: FC<FreeTrialLinkBannerProps> = ({ variant }) => {
  const { t } = useTranslation('common')
  const [isSalesOpen, setIsSalesOpen] = useState(false)

  return (
    <>
      {isSalesOpen && <ContactSalesModal onClose={() => setIsSalesOpen(false)} />}

      {/* `border-[1px]` not `border`: Bootstrap ships its own `.border` shorthand with
          !important, which lands after Tailwind and would repaint the edge grey.
          The `shadow:` hint is required too, or Tailwind reads the var as a shadow colour. */}
      <div className="flex items-center gap-[16px] px-[24px] py-[16px] rounded-xl border-[1px] border-solid border-gray-1 bg-gray-6-filled shadow-[shadow:var(--form-shadow)]">
        <div className="flex flex-1 items-center gap-[16px] min-w-0">
          {/* The shared icon dims its stroke by default; the banner uses it at full weight. */}
          <InfoSVGIcon className="shrink-0 size-[16px] text-gray-1 [&_path]:[stroke-opacity:1]" />
          <div className="flex flex-col gap-[2px] min-w-0">
            <span className="font-switzer-main font-semibold text-[14px] leading-none text-gray-1">
              {t('free_trial_link_banner.title')}
            </span>
            <span className="font-switzer-main text-[12px] leading-[1.1] text-gray-3">
              {t(SUBTITLE_KEYS[variant])}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="shrink-0 bg-transparent border-none p-0 cursor-pointer font-switzer-main font-semibold text-[14px] leading-none text-gray-1"
          onClick={() => setIsSalesOpen(true)}
        >
          {t('free_trial_link_banner.contact_sales')}
        </button>
      </div>
    </>
  )
}

export default FreeTrialLinkBanner
